import script from "./Memberships.vue?vue&type=script&lang=ts&setup=true"
export * from "./Memberships.vue?vue&type=script&lang=ts&setup=true"

import "./Memberships.vue?vue&type=style&index=0&id=0f40da98&lang=scss&scoped=true"
script.__scopeId = "data-v-0f40da98"

export default script